import { COLORS } from '@btime/constants'
import { useTranslation } from 'react-i18next'
import React from 'react'
import Tag from '../../components/presentation/Tag'

const AppMigrationTag = ({ isUsingNewApp }) => {
  const { t } = useTranslation()

  const color = isUsingNewApp ? COLORS.green : COLORS.red
  const label = isUsingNewApp ? t('yes') : t('no')

  return <Tag label={label} bgColor={color} />
}

export default AppMigrationTag
